import { IMonHocActionTypes } from "../../action-types/category/IMonHocActions";
import { IMonHocReducer } from "../../reducer-model/category/IMonHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IMonHocReducer = {
    status: eReducerStatusBase.is_not_initialization,
    monHocs: [],
    listIdsChange: [],
};

export const monHocReducer = (
 state: IMonHocReducer = iniState,
 action: IMonHocActionTypes
): IMonHocReducer => {
   switch (action.type) {
    case "MON_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MON_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        monHocs: action.payload,
      };
    case "MON_HOC_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_HOC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        monHocEditing: action.payload
      };
    case "MON_HOC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "MON_HOC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MON_HOC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "MON_HOC_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_HOC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "MON_HOC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MON_HOC_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_HOC_SAVE_CONG_THUC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MON_HOC_SAVE_CONG_THUC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MON_HOC_SAVE_CONG_THUC_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_HOC_CHANGE_CONG_THUC_MON":
      return {
        ...state,
        monHocs: state.monHocs.map((monHoc) => {
          if (monHoc.id_mon === action.payload.id_mon) {
            return {
              ...monHoc,
              id_cong_thuc_mon: action.payload.id_cong_thuc_mon,        
            };
          }
          return monHoc;
        }),
        listIdsChange: [...state.listIdsChange ?? [], action.payload.id_mon]
      };
    case "MON_HOC_UPLOAD_CONG_THUC_MODAL_OPEN":
      return {
        ...state,
        isShowUploadCongThucModal: true,
      };
    case "MON_HOC_UPLOAD_CONG_THUC_MODAL_CLOSE":
      return {
        ...state,
        isShowUploadCongThucModal: false,
      };
    default:
      return state;
  }
};
